
import { Component, Mixins } from 'vue-property-decorator';
import CallToAction from '@hokify/shared-components/lib/components/CallToAction.vue';
import ArticlePage from '@hokify/shared-components/lib/components/Article/ArticlePage.vue';
import Article from '~/mixins/Article';
import ItemList from '~/components/website/list/ItemList.vue';
import SeoFooter from '~/components/website/footer/SeoFooter.vue';

/* reference for wildcard alias:
https://stackoverflow.com/questions/63526486/vue-router-catch-all-wildcard-not-working */

@Component({
	name: 'UserArticlePage',
	components: {
		SeoFooter,
		ArticlePage,
		CallToAction, // dont use hydrate wrappers as it is visible on desktop above the fold and it rerenders!
		ItemList // dont use hydrate wrappers as it is visible on desktop above the fold and it rerenders!
	},
	layout: 'plain-user'
})
export default class UserArticlePage extends Mixins(Article) {
	articlesPerApiCall = 12;

	async loadMoreArticles(count) {
		const newArticles = await this.loadArticlesForCategory({
			category: this.myArticle.category?.identifier,
			page: count / this.articlesPerApiCall,
			limit: this.articlesPerApiCall
		});
		this.linkedArticles = this.linkedArticles.concat(newArticles);
		return newArticles.length === this.articlesPerApiCall;
	}

	get bannerLink(): string {
		if (this.myArticle.isCoreArticle) {
			return '/karriere';
		}
		return `/karriere/${this.myArticle.category?.coreArticle?.alias || ''}`;
	}

	get bannerHeadline(): string {
		if (this.myArticle.isCoreArticle) {
			return 'Tipps für deine erfolgreiche Jobsuche & Bewerbung!';
		}
		return this.myArticle.category?.ctaText || '';
	}

	get bannerButtonText(): string {
		if (this.myArticle.isCoreArticle) {
			return 'Zurück zur Übersicht';
		}
		if (this.$isMobile.phone) {
			return this.myArticle.category?.ctaButtonTextMobile || '';
		}
		return this.myArticle.category?.ctaButtonText || '';
	}
}
